<template>
  <v-container>
    <div
      class="display-2 mb-7 mt-5 font-weight-thin"
      color="primary"
    >{{$tc('entities.account.title',2)}}</div>
    <alert-box v-model="alert.alerts" :type="alert.type"></alert-box>
    <btn-a rounded color="primary" @click="editItem" :access="$access.account.edit">
      <v-icon>mdi-plus</v-icon>
    </btn-a>
    <table-grid
      :noAction="noAction"
      :multiple="multiple"
      :singleSelect="singleSelect"
      :headers="headers"
      :items="items"
      :loading="loadingTable"
      :loadingAction="loadingDialog"
      :actions="actions"
      :page="pagination.page"
      :pageLength="lengthPaginationComp"
      @input="pagination.page = $event"
      @click="clickTable($event)"
      @search="searchTable"
    />

    <dialog-d
      ref="dialogEdit"
      :title="$tc('entities.account.title',1)"
      :deleteButton="itemSelected && itemSelected.id"
      @confirm="saveItem(itemSelected,$refs.form.isValid())"
      @delete="deleteItem(itemSelected,true)"
      :loading="loadingDialog"
      :accessConfirm="$access.account.edit"
      :accessDelete="$access.account.delete"
      :alert="form.alert"
    >
      <accountForm ref="form" v-model="itemSelected" />
    </dialog-d>
  </v-container>
</template>

<script>
import accountService from "@/services/accountService";
import accountForm from "../components/forms/accounts/accountForm";
import pageListMixing from "../mixins/pageLists/pageListMixing.js";
export default {
  mixins: [pageListMixing],
  components: { accountForm },

  data() {
    return {
      apiController: "account",
      entityService: accountService,
      searchFields: ["code", "name"],
      headers: [
        {
          text: this.$t("entities.account.props.code"),
          align: "left",
          sortable: false,
          value: "code",
        },
        {
          text: this.$t("entities.account.props.name"),
          align: "left",
          sortable: false,
          value: "name",
        },

        {
          text: this.$t("table.actions"),
          value: "action",
          sortable: false,
          align: "right",
        },
      ],
      actions: [
        {
          text: this.$t("edit"),
          icon: "mdi-pencil",
          handle: this.editItem,
          access: [this.$access.account.edit, this.$access.account.show],
        },
        {
          text: this.$t("delete"),
          icon: "mdi-delete",
          handle: this.deleteItem,
          access: this.$access.account.delete,
        },
      ],
    };
  },
  methods: {
    async getModelDefault() {
      return {
        code: await this.getAutoInc(this.apiController),
        name: "",
        customFields: {},
      };
    },
  },
  async mounted() {
    await this.getItems();
  },
};
</script>